/**
 * Popup "-10% sur ta première commande".
 *
 * Déclenché à l'intention de sortie (souris qui quitte la fenêtre par le
 * haut, desktop) ou après 30 secondes (mobile, où ce signal n'existe pas).
 * Affiché une seule fois par navigateur (localStorage), jamais si déjà
 * inscrit à la newsletter. Le formulaire est un vrai formulaire client
 * Shopify ({% form 'customer' %}) : la soumission recharge la page, et
 * c'est `form.posted_successfully?` (transmis via data-posted-successfully)
 * qui déclenche l'affichage de l'état "merci" au retour.
 *
 * Volontairement PAS de déclencheur au scroll : scroller loin dans une
 * fiche produit est un signal d'engagement, pas d'intention de départ —
 * interrompre à ce moment-là nuirait à la conversion plutôt que de l'aider.
 */
if (!customElements.get('exit-popup-component')) {
  customElements.define(
    'exit-popup-component',
    class ExitPopupComponent extends HTMLElement {
      connectedCallback() {
        this.closeButton = this.querySelector('.exit-popup__close');
        this.dismissButton = this.querySelector('.exit-popup__dismiss');

        this.closeButton?.addEventListener('click', () => this.hide());
        this.dismissButton?.addEventListener('click', () => this.hide());
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });

        // Retour après soumission réussie du formulaire natif Shopify :
        // on affiche directement l'état "merci" déjà rendu côté Liquid.
        if (this.dataset.postedSuccessfully === 'true') {
          this.markSubscribed();
          this.show();
          return;
        }

        if (this.shouldSkip()) return;

        this.armTriggers();
      }

      shouldSkip() {
        if (this.dataset.alreadySubscribed === 'true') return true;
        try {
          return (
            window.localStorage.getItem('bbp_popup_shown') === '1' ||
            window.localStorage.getItem('bbp_newsletter_subscribed') === '1'
          );
        } catch (error) {
          return false;
        }
      }

      armTriggers() {
        let triggered = false;
        let timer;

        const trigger = () => {
          if (triggered) return;
          triggered = true;
          this.show();
          document.removeEventListener('mouseout', onMouseOut);
          clearTimeout(timer);
        };

        const onMouseOut = (event) => {
          if (!event.relatedTarget && event.clientY <= 0) trigger();
        };

        document.addEventListener('mouseout', onMouseOut);
        timer = setTimeout(trigger, 30000);
      }

      show() {
        this.classList.add('exit-popup-overlay--visible');
        try {
          window.localStorage.setItem('bbp_popup_shown', '1');
        } catch (error) {
          /* localStorage indisponible (navigation privée, etc.) : on ignore. */
        }
      }

      hide() {
        this.classList.remove('exit-popup-overlay--visible');
      }

      markSubscribed() {
        try {
          window.localStorage.setItem('bbp_newsletter_subscribed', '1');
        } catch (error) {
          /* localStorage indisponible : on ignore. */
        }
      }
    }
  );
}
